import socket from '../socket';

export class RestResources {
    static getResources(): Promise<any>{
        return new Promise(async (resolve, reject) => {
            try {
                socket.emit('get-resources', (response: any) => {
                    resolve(response)
                })
            } catch (e) {  reject(e)}
        })
    }
}
